import { useQuery } from '@tanstack/react-query';
import { useAPISettingsApi } from './use-api-settings-api';

export const QK_API_SETTINGS_LIST_KEYS = () => ['api-settings-keys'] as const;

export function useAPISettingsKeys() {
  const { APISettingsApi } = useAPISettingsApi();

  const query = useQuery({
    queryKey: QK_API_SETTINGS_LIST_KEYS(),
    queryFn: () => APISettingsApi.list(),
  });

  return {
    ...query,
    data: query.data ?? [],
  };
}
